module.exports = __webpack_public_path__ + "media/images/arrow-6272efd9eb60f77eba0a538319fa7df3.png";